<template>
  <!-- transferExceptionWarning Modal -->
  <div
    class="modal fade"
    id="transferExceptionWarningModal"
    tabindex="-1"
    aria-labelledby="transferExceptionWarningModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="transferExceptionWarningModalLabel">
            Transfer Exception Details
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <vue-good-table
            class="vue-table"
            ref="table"
           
            :key="tableKey"
            @page-change="onPageChange"
            @per-page-change="onPerPageChange"
            :isLoading.sync="isLoading"
            :pagination-options="paginationOptions"
            :totalRows="transferStore.totalRecordsWarning"
            :rows="transferStore.currentTransferExceptionWarning"
            :columns="paginationData.columns"
          >
            <template #table-actions-bottom>
              <pagination-records
                :pages="serverParams.page"
                :per-page="serverParams.perPage"
                :total="transferStore.totalRecordsWarning"
              />
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>

  <!-- transferExceptionCritical Modal -->
  <div
    class="modal fade"
    id="transferExceptionCriticalModal"
    tabindex="-1"
    aria-labelledby="transferExceptionCriticalModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="transferExceptionCriticalModalLabel">
            Transfer Exception Details
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <vue-good-table
            class="vue-table"
            ref="table"
            
            :key="tableKey"
            @page-change="onPageChange"
            @per-page-change="onPerPageChange"
            :isLoading.sync="isLoading"
            :pagination-options="paginationOptions"
            :totalRows="transferStore.totalRecordsCritical"
            :rows="transferStore.currentTransferExceptionCritical"
            :columns="paginationData.columns"
          >
            <template #table-actions-bottom>
              <pagination-records
                :pages="serverParams.page"
                :per-page="serverParams.perPage"
                :total="transferStore.totalRecordsCritical"
              />
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>

  <!-- transferExceptionNonCritical Modal -->
  <div
    class="modal fade"
    id="transferExceptionNonCriticalModal"
    tabindex="-1"
    aria-labelledby="transferExceptionNonCriticalModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="transferExceptionNonCriticalModalLabel">
            Transfer Exception Details
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <vue-good-table
            class="vue-table"
            ref="table"
            
            :key="tableKey"
            @page-change="onPageChange"
            @per-page-change="onPerPageChange"
            :isLoading.sync="isLoading"
            :pagination-options="paginationOptions"
            :totalRows="transferStore.totalRecordsNonCritical"
            :rows="transferStore.currentTransferExceptionNonCritical"
            :columns="paginationData.columns"
          >
            <template #table-actions-bottom>
              <pagination-records
                :pages="serverParams.page"
                :per-page="serverParams.perPage"
                :total="transferStore.totalRecordsNonCritical"
              />
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PaginationRecords from "@/components/Pagination/PaginationRecords.vue";
import { formatExceptionDate } from "@/composables/useDateConversion";
import { useTransferStore } from "@/stores/content_review/transfer";
import { useAsyncState } from "@vueuse/core";
import { ref, watch } from "vue";

const tableKey = ref(0);
const transferId = ref();
const transferStore = useTransferStore();
const isLoading = ref(false);

const forceRerender = () => {
  tableKey.value += 1;
};

const props = defineProps({
  transferId: { type: String, required: true },
});

watch(
  () => props.transferId,
  (val) => {
    transferId.value = val;
    forceRerender();
    updateParams({
      page: 1,
      perPage: paginationOptions.value.perPageDropdown[1],
      startingAfter: "",
    });
  }
);

watch(
  () => transferStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

const paginationOptions = ref({
  enabled: true,
  mode: "pages",
  position: "bottom",
  perPageDropdown: [10, 20, 30],
  perPage: 20,
  dropdownAllowAll: false,
});

const serverParams = ref({
  page: 1,
  perPage: paginationOptions.value.perPageDropdown[1],
  startingAfterWarning: "",
  startingAfterCritical: "",
  startingAfterNonCritical: "",
});

const checkObject = (rowObj) => {
  if (rowObj.object == null) return "-";
  else return rowObj.object;
};

const checkName =(rowObj) =>{
  var newName = rowObj.name;
  
  if (newName!= null){
    var finalName = newName.replaceAll('--->','<br>');
    return finalName;
  }else {
    return newName;
  }
  
 

  
  
};

let paginationData = {
  totalRecordsWarning: transferStore.totalRecordsWarning,
  totalRecordsCritical: transferStore.totalRecordsCritical,
  totalRecordsNonCritical: transferStore.totalRecordsNonCritical,
  columns: [
    { label: "Name", field: checkName, sortable: false ,html:true},
    {
      label: "Object",
      field: checkObject,
      sortable: false,
    },
    { label: "Activity", field: "activity", sortable: false },
    {
      label: "Exception Type",
      field: "transferExceptionType",
      sortable: false,
    },
    {
      label: "Exception Date",
      field: formatExceptionDate,
      sortable: false,
    },
  ],
};

const { execute } = useAsyncState(() => {
  return (
    transferStore.fetchTransferExceptionWarning(
      transferId.value,
      serverParams.value.perPage,
      serverParams.value.startingAfterWarning as string
    ),
    transferStore.fetchTransferExceptionCritical(
      transferId.value,
      serverParams.value.perPage,
      serverParams.value.startingAfterCritical as string
    ),
    transferStore.fetchTransferExceptionNonCritical(
      transferId.value,
      serverParams.value.perPage,
      serverParams.value.startingAfterNonCritical as string
    )
  );
}, null);

const updateParams = (newProps: any) => {
  serverParams.value = Object.assign({}, serverParams.value, newProps);
};

const onPageChange = (params) => {
  updateParams({
    perPage: params.currentPerPage,
    page: params.currentPage,
    startingAfterWarning: countStartingAfterWarning(params),
    startingAfterCritical: countStartingAfterCritical(params),
    startingAfterNonCritical: countStartingAfterNonCritical(params),
  });
  // execute();
};

const onPerPageChange = (params) => {
  updateParams({
    perPage: params.currentPerPage,
    page: 1,
    startingAfterWarning: "",
    startingAfterCritical: "",
    startingAfterNonCritical: "",
  });
  // execute();
};

const countStartingAfterWarning = (params) => {
  let firstId: any = transferStore.firstIdWarning;
  return firstId - 1 + params.currentPerPage * (params.currentPage - 1);
};

const countStartingAfterCritical = (params) => {
  let firstId: any = transferStore.firstIdCritical;
  return firstId - 1 + params.currentPerPage * (params.currentPage - 1);
};

const countStartingAfterNonCritical = (params) => {
  let firstId: any = transferStore.firstIdNonCritical;
  return firstId - 1 + params.currentPerPage * (params.currentPage - 1);
};
</script>
